module.exports = __webpack_public_path__ + "static/media/IS.f4178f5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IS.svg
// module id = 2177
// module chunks = 7